import { React, useState, Fragment, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import apiService from '../../services/apiServices';
import fiscalValidationSchema from '../../services/fiscalValidationSchema';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import { yupResolver } from '@hookform/resolvers/yup';
import EditIcon from '@mui/icons-material/Edit';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useParams } from 'react-router-dom';
import globals from '../../services/globals';

const AddFiscalPolitic = () => {
    const logedInUser = globals().getLogedInUser()
    const { id } = useParams();
    const status = { added: 1, deleted: -1, changed: 2, unchanged: 0 };
    const alert = { open: false, message: '', variant: '' };
    const [toast, setToast] = useState(alert);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const obj = { id: 0, From: 0.0, To: 0.0, Tax: 0, editMode: false, no: 1, status: 0 }
    const [salaries, setSalaries] = useState([obj]);
    const {
        register,
        handleSubmit,
        control,
        setValue,
        watch,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(fiscalValidationSchema),
    });
    const brutoNeto = [{ id: 0, name: "" }, { id: 1, name: "Bruto" }, { id: 2, name: "Neto" }]

    const onRowClick = (no) => {
        let rowItem = [...salaries]
        rowItem.forEach(i => i.editMode = false);
        rowItem[no - 1].editMode = !rowItem[no - 1].editMode;
        setSalaries(rowItem);
    }

    const addRow = () => {
        let newItem = obj
        newItem.no = Math.max(...salaries.map(o => o.no), 0) + 1
        const newState = [...salaries, newItem];
        setSalaries(countItems(newState))
    }

    const deleteRow = (rowId) => {
        let arrayCopy = [...salaries]
        let item = arrayCopy.find(i => i.no === rowId);
        item.status = -1; //status.deleted;
        setSalaries(countItems(arrayCopy))
    }

    const countItems = (arr) => {
        let count = 1;
        arr.forEach(i => { i.no = count; count++ });
        return arr;
    }


    const onValueChange = (no) => {
        let newArr = [...salaries];
        newArr[no - 1]['status'] = status.changed;
        newArr[no - 1]['From'] = parseFloat(watch('From_' + no))
        newArr[no - 1]['To'] = parseFloat(watch('To_' + no))
        newArr[no - 1]['Tax'] = watch('Tax_' + no)
        setSalaries(newArr);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const reOrderItems = (items) => {
        let count = 1;
        items.forEach(i => {
            if (i.status !== -1) {
                i.no = count;
                count++
            }
            else {
                i.no = 0;
            }
        });

        return items;
    }

    const setEditModeFalse = (items) => {
        return items.map(obj => ({ ...obj, editMode: false }))
    }

    const saveSalaries = (list) => {
        let objs = [], items = reOrderItems([...salaries]), objE = {};

        items?.forEach(item => {
            item.fiscalPoliticsId = list.id;
            item.CreatedBy = logedInUser.data.username
            if (item.id === 0) {
                objE = {};
                objE.id = 0;
                objE.entity = item;
                objE.status = status.added;
                objE.type = "fiscalPoliticsDetails";

                if (item.WorkerId !== 0 && item.no !== 0 && item.status !== -1) {
                    objs.push(objE);
                }
            }
            else {
                objE = {};
                objE.entity = item;
                objE.status = item.status ? item.status : status.unchanged;
                objE.type = "fiscalPoliticsDetails";
                if (objE.status !== status.unchanged) {
                    objs.push(objE)
                }
            }
        });

        console.log(objs)

        if (objs.length > 0) {
            apiService().saveChanges(objs)
                .then((response) => {
                    if (response.success) {
                        setToast({
                            open: true,
                            message: 'U ruajten me sukses!',
                            variant: 'success',
                        });
                        setSalaries(setEditModeFalse(salaries))
                        if (!id) {
                            window.location.href = '#/fiscal/editfiscal/' + list.id
                        }
                    }
                    else {
                        setToast({
                            open: true,
                            message: 'Ka ndodhur nje gabim!',
                            variant: 'error',
                        });
                    }
                })
        }
        else {
            if (id) {
                setToast({
                    open: true,
                    message: 'Nuk ka ndryshime!',
                    variant: 'info',
                });
            }
            else {
                setToast({
                    open: true,
                    message: 'U ruajten me sukses!',
                    variant: 'success',
                });
            }

        }
    }

    const onSubmit = (data) => {
        console.log(data);
        data.Type = data.Type.id;
        data.CreatedBy = logedInUser.data.username;
        apiService().post('fiscalPolitics', data)
            .then((response) => {
                console.log(response)
                if (response.success) {
                    saveSalaries(response.data)
                    setToast({
                        open: true,
                        message: 'U ruajten me sukses!',
                        variant: 'success',
                    });
                } else {
                    setToast({
                        open: true,
                        message: 'Ka ndodhur nje gabim!',
                        variant: 'error',
                    });
                }
            });
    };

    return (
        <div>
            <Fragment>
                <Toast {...toast} />
                <TopActions
                    // newHref={() => addRow()}
                    addNew={() => addRow()}
                    save={handleSubmit(onSubmit)}
                />

                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Të dhënat
                        </Typography>
                        <form>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Prej"
                                        error={errors.From}
                                        control={control}
                                        register={{ ...register('From') }}
                                        name="From"
                                        type="date"
                                        value={watch('From')}
                                        onFieldChange={(e) => setValue('From', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Deri"
                                        error={errors.To}
                                        control={control}
                                        register={{ ...register('To') }}
                                        name="To"
                                        type="date"
                                        value={watch('To')}
                                        onFieldChange={(e) => setValue('To', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} lg={3}>
                                    <SelectController
                                        placeholder="Tipi"
                                        error={errors.Type}
                                        control={control}
                                        options={brutoNeto}
                                        name="Type"
                                        register={{ ...register('Type') }}
                                        value={watch('Type')}
                                        onFieldChange={(e) => console.log(e)}
                                    />
                                </Grid>
                                {/* <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Përqindja"
                                        error={errors.Percentage}
                                        control={control}
                                        symbol="%"
                                        register={{ ...register('Percentage') }}
                                    />
                                </Grid> */}

                            </Grid>
                        </form>
                    </CardContent>
                </Card>
                <Card style={{ marginTop: '16px' }}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Lista e punetoreve
                        </Typography>

                        <TableContainer component={Paper}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nr</TableCell>
                                        <TableCell>Prej</TableCell>
                                        <TableCell>Deri</TableCell>
                                        <TableCell>Tatimi</TableCell>
                                        <TableCell>Add/Remove</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {salaries?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((w, index) => (w.status !== -1 &&
                                        <TableRow key={w.Id + index}>

                                            <TableCell>{index + 1}</TableCell>

                                            {
                                                w.editMode ?
                                                    <TableCell>
                                                        <InputController onFieldChange={() => onValueChange(w.no)} error={errors['From_' + w.no]} control={control} symbol="€" name={`From_${w.no}`} register={{ ...register('From_' + w.no) }} value={watch('From_' + w.no)} />
                                                    </TableCell>
                                                    :
                                                    <TableCell onClick={function () { onRowClick(w.no) }}>
                                                        {new Intl.NumberFormat('en-GB', {
                                                            style: 'currency',
                                                            currency: 'EUR',
                                                        }).format(w.From)}
                                                    </TableCell>
                                            }
                                            {
                                                w.editMode ?
                                                    <TableCell><InputController onFieldChange={() => onValueChange(w.no)} error={errors['To_' + w.no]} control={control} symbol="€" name={`To_${w.no}`} register={{ ...register('To_' + w.no) }} value={watch('To_' + w.no)} /></TableCell>
                                                    :
                                                    <TableCell onClick={function () { onRowClick(w.no) }}>
                                                        {new Intl.NumberFormat('en-GB', {
                                                            style: 'currency',
                                                            currency: 'EUR',
                                                        }).format(w.To)}
                                                    </TableCell>
                                            }
                                            {
                                                w.editMode ?
                                                    <TableCell><InputController onFieldChange={() => onValueChange(w.no)} error={errors['Tax_' + w.no]} control={control} symbol="%" name={`Tax_${w.no}`} register={{ ...register('Tax_' + w.no) }} value={watch('Tax_' + w.no)} /></TableCell>
                                                    :
                                                    <TableCell onClick={function () { onRowClick(w.no) }}>
                                                        <p>{watch('Tax_' + w.no)} %</p>
                                                    </TableCell>
                                            }
                                            <TableCell>
                                                <ButtonGroup size="small">
                                                    <Button onClick={() => deleteRow(w.no)}>
                                                        <DeleteIcon />
                                                    </Button>
                                                    {salaries.length === index + 1 &&
                                                        <Button onClick={() => addRow()}>
                                                            <AddIcon />
                                                        </Button>
                                                    }
                                                </ButtonGroup>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={salaries.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </CardContent>
                </Card>
            </Fragment>
        </div>
    )
}

export default AddFiscalPolitic